// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-container {
  width: 100%;
  height: 100%;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background-color: #FDFDFD;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  z-index: 10000;
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
}

.search-event-card .dot {
  display: inline-block;
  width: 2px;
  height: 2px;
  margin: 0 8px;
  border-radius: 50%;
  background-color: #717171; /* Or whatever color you want */
  vertical-align: middle;
}

.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.bd {
  border-radius: 8px;
  border: 1px solid rgba(255, 36, 89, 0.1);
  background: #FDFDFD;
}

.bd-2 {
  border-radius: 16px;
  border: 1px solid #F3F3F3;
  background: #FDFDFD;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.bd-3 {
  border-radius: 12px;
  border: 1px solid var(--Grey-10, #F3F3F3);
  background: var(--White, #FDFDFD);
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}

.hover:hover {
  background-color: #F3F3F3;
}

@media screen and (max-width: 650px) {
  .search-container {
    padding: 24px;
  }
  .bd-2 {
    border-radius: none;
    border: none;
    background: none;
    box-shadow: none;
  }
}
.no-scroll {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/searchbar/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,wEAAA;AACJ;;AAGI;EACI,qBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA,EAAA,+BAAA;EACA,sBAAA;AAAR;;AAIA;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,wCAAA;EACA,mBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kDAAA;AADJ;;AAIA;EACI,mBAAA;EACA,yCAAA;EACA,iCAAA;EACA,8FAAA;AADJ;;AAIA;EACI,yBAAA;AADJ;;AAIA;EACI;IACI,aAAA;EADN;EAIE;IACI,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;EAFN;AACF;AAKA;EACI,gBAAA;AAHJ","sourcesContent":[".search-container{\n    width:100%;\n    height:100%;\n    padding-top: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap:24px;\n    background-color: theme('colors.white');\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(10px);\n    z-index: 10000;\n    transition: opacity 0.3s ease, transform 0.3s ease,visibility 0.3s ease;\n}\n\n.search-event-card {\n    .dot {\n        display: inline-block;\n        width: 2px;\n        height: 2px;\n        margin: 0 8px;\n        border-radius: 50%;\n        background-color: theme('colors.grey-70'); /* Or whatever color you want */\n        vertical-align: middle;\n    }\n}\n\n.show{\n    opacity: 1 ;\n    visibility: visible ;\n    transform: translateY(0);\n}\n\n.bd{\n    border-radius: 8px;\n    border: 1px solid rgba(255, 36, 89, 0.10);\n    background: theme('colors.white');\n}\n\n.bd-2{\n    border-radius: 16px;\n    border: 1px solid theme('colors.grey-10');\n    background: theme('colors.light-white');\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n\n.bd-3{\n    border-radius: 12px;\n    border: 1px solid var(--Grey-10, #F3F3F3);\n    background: var(--White, #FDFDFD);\n    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);\n}\n\n.hover:hover{\n    background-color: #F3F3F3;\n}\n\n@media screen and (max-width: 650px) {\n    .search-container{\n        padding: 24px;\n    }\n\n    .bd-2{\n        border-radius: none;\n        border: none;\n        background:none;\n        box-shadow: none;\n    }\n}\n\n.no-scroll {\n    overflow: hidden;\n    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
